<app-card-auth
	title="Jelszó visszaállítása"
	description="Kérjük, adja meg a regisztrációhoz használt e-mail címet, és e-mailben küldünk egy linket a jelszó visszaállításához."
>
	<reset-password-form
		[signInLink]="defaultLink"
		[buttonLink]="buttonLink"
	></reset-password-form>
</app-card-auth>
